<telxl-shared-overlay-modal>
    <ng-template #modalBody>
        <div
            class="d-flex align-items-center justify-content-center flex-column p-2"
        >
            <i class="fa-light fa-triangle-exclamation"></i>
            <p class="font-xs text-center mt-3 mb-3">
                Are you sure you want to swap the customer data in focus with
                the data for
            </p>
            <p class="font-lg text-center">
                &#x201C;{{ swapToName() }}&#x201D;
            </p>
            <div class="d-flex justify-content-center">
                <telxl-button
                    class="me-1"
                    colour="secondary"
                    [outline]="true"
                    (buttonClick)="close(false)"
                >
                    Cancel
                </telxl-button>
                <telxl-button
                    class="ms-1"
                    colour="primary"
                    [outline]="true"
                    (buttonClick)="close(true)"
                >
                    Swap
                </telxl-button>
            </div>
        </div>
    </ng-template>
</telxl-shared-overlay-modal>
